import React, { useEffect } from 'react'; 
import styles from '../css/Sidebar.module.css';  
import iconImg from "../assets/cameraIcon.png"; 
import { LogOut } from 'react-feather'; 
import { Navigate, Link } from 'react-router-dom';   

const Sidebar = ({ activeSection, setActiveSection }) => {   
  const [isLoggedOut, setIsLoggedOut] = React.useState(false);      

  function handleLogout() {     
    localStorage.removeItem('token');     
    localStorage.removeItem('user');     
    setIsLoggedOut(true);   
  }     

  useEffect(() => {     
    const token = localStorage.getItem('token');     
    if (!token) {       
      setIsLoggedOut(true);      
    }   
  }, []);   

  if (isLoggedOut) {     
    return <Navigate to="/login" />;   
  }    

  function LogoutButton() {     
    return (       
      <button onClick={handleLogout} className={styles.logoutButton}>         
        <LogOut /> Logout       
      </button>     
    );   
  }    

  return (     
    <div className={styles.sidebar}>       
      <h2>         
        <img src={iconImg} alt="Sidebar Icon" className={styles.sidebarIcon} />         
        ImageX 
      </h2>        

      <ul>         
        <li>           
          <Link 
            to="/upload"  
            className={activeSection === 'upload' ? styles.active : ''}
            onClick={() => setActiveSection('upload')}           
          >             
            Add Image           
          </Link>         
        </li>         
        <li>           
          <Link 
            to="/history" 
            className={activeSection === 'history' ? styles.active : ''}
            onClick={() => setActiveSection('history')}           
          >             
            History           
          </Link>         
        </li>       
      </ul>        

      <div className={styles.logoutContainer}>         
        <LogoutButton />       
      </div>     
    </div>   
  ); 
};

export default Sidebar;
